import fi from "./trigger-condition.js";
export default class mi {
  constructor(t, i) {
    (this.rf = t), (this.nf = i), (this.rf = t), (this.nf = i);
  }
  sf(t) {
    if (null == this.rf) return !1;
    const i = fi.ef(t[0], this.rf);
    if (!i) return !1;
    let r = null == this.nf || 0 === this.nf.length;
    if (null != this.nf)
      for (let i = 0; i < this.nf.length; i++)
        if (this.nf[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new mi(t ? t.id : null, t ? t.buttons : null);
  }
  gt() {
    return this.rf;
  }
}
